/* ==========================================================================
   Fair-Turbo — Micro-Animationen, 22.07.2026 (Scroll-Reveal)
   + 23.07.2026: Hero-Fakten-Chips gestaffelt beim Laden (chipIntro, unten).
   Pascal: „die animation auf meinem webshop auch ausbaufaehig".

   RUHIG UND SICHER — drei Grundsaetze:

   1) OHNE DIESES SCRIPT IST NIE ETWAS VERSTECKT.
      Das Reveal-CSS in ft-tokens.css greift nur unter html.ft-motion und
      nur auf Elementen mit .ft-reveal — BEIDE Klassen setzt ausschliesslich
      dieses Script. Kein JS / JS-Fehler => alles bleibt sichtbar.

   2) KEIN AUFBLITZEN BEIM LADEN.
      Elemente, die beim Scan bereits (teilweise) im Viewport stehen, werden
      gar nicht erst angefasst — sie sind womoeglich schon gemalt, ein
      nachtraegliches Verstecken wuerde sichtbar flackern. Animiert wird
      nur, was unterhalb/ausserhalb liegt und erst per Scroll erscheint.

   3) PERFORMANT UND SELBSTAUFRAEUMEND.
      Nur opacity/transform (Compositor), IntersectionObserver statt
      Scroll-Handler, unobserve nach dem ersten Sichtbarwerden, disconnect
      sobald nichts mehr aussteht. Nach der Animation werden die Klassen
      und die Delay-Variable wieder entfernt — danach gelten die normalen
      Hover-Transitions der Karten (z. B. .ft-pc) unveraendert, und
      will-change belegt keinen Speicher mehr.

   Staffelung: Elemente, die im selben Observer-Durchlauf sichtbar werden,
   bekommen --ft-reveal-i = 0..5 (je 60 ms Versatz). So staffelt jede
   Kartenreihe fuer sich, statt dass spaete Rasterkinder pauschal warten.
   ========================================================================== */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  var mq = null;
  try { mq = window.matchMedia('(prefers-reduced-motion: reduce)'); } catch (e) { /* egal */ }
  if (mq && mq.matches) return;

  /* Nur diese Container werden animiert (jeweils die DIREKTEN Kinder).
     BEWUSST keine generischen .ft-grid-3/.ft-grid-4: die stecken auch in
     Header-Mega-Menue und Brand-Navigation — dort hat Reveal nichts verloren.
     Footer ebenfalls BEWUSST nicht: am Fold-Ende sieht den Einstieg kaum
     jemand, dort waere Reveal nur Unruhe. */
  var GROUP_SELECTOR = [
    '.ft-prod-grid',        /* Produktkarten: Kategorie + Suche          */
    '.ft-fpb-track',        /* Produktkarten: Startseite (Featured)      */
    '.ft-sortiment-raster', /* Sortiment-Kacheln Startseite              */
    '.ft-zvgl-grid',        /* Neu-vs-Generalueberholt-Karten            */
    '.ft-ablauf-liste',     /* Pfand-Ablauf-Schritte                     */
    '.ft-trustband-row',    /* USP-Spalten (Vertrauensband)              */
    '.ft-nrf-grid',         /* Nummer-finden: Kopf/Wege/Fuss (23.07.)    */
    '.ft-kontakt-aktionen'  /* Beratung: WhatsApp-/Formular-CTA (23.07.) */
  ].join(',');

  var STEP_MS = 60;     /* Staffelungs-Schritt                            */
  var DURATION_MS = 380;/* muss zur Transition in ft-tokens.css passen    */
  var MAX_STEP = 5;     /* Delay-Deckel: max. 300 ms, bleibt ruhig        */

  var io = null;
  var pending = 0;

  function strip(el) {
    el.classList.remove('ft-reveal');
    el.classList.remove('is-inview');
    el.style.removeProperty('--ft-reveal-i');
  }

  /* Notbremse: alles sofort sichtbar machen (Fehlerfall, Reduced-Motion-
     Umschaltung zur Laufzeit). Idempotent. */
  function revealAll() {
    if (io) { io.disconnect(); io = null; }
    pending = 0;
    var rest = document.querySelectorAll('.ft-reveal');
    for (var i = 0; i < rest.length; i++) strip(rest[i]);
  }

  /* Gezielte Notbremse (09.08.2026): gibt NUR frei, was gerade im
     sichtbaren Bereich steht und trotzdem noch versteckt ist. Alles
     weiter unten wartet unveraendert auf seinen Auftritt.

     Warum es das braucht: Liegt das Fenster im Hintergrund, liefert der
     IntersectionObserver keine Meldungen — beim Zurueckwechseln kann ein
     Element dann versteckt haengen bleiben. Gemessen an der fuenften
     Zusage im Vertrauensband. Eine Zusage, die gar nicht erscheint, ist
     teurer als eine ohne Animation. */
  function freeVisible() {
    if (!pending) return;
    /* NUR was noch NICHT gemeldet wurde. Elemente mit is-inview hat der
       Beobachter bereits gezaehlt; sie tragen .ft-reveal nur noch, bis ihr
       Aufraeum-Timer laeuft. Wer sie hier noch einmal herunterzaehlt,
       treibt pending vorzeitig auf 0 — dann schaltet sich der Beobachter
       ab und ALLES Uebrige bleibt fuer immer unsichtbar. Genau das ist am
       09.08. im Pfand-Ablauf passiert. */
    var rest = document.querySelectorAll('.ft-reveal:not(.is-inview)');
    if (!rest.length) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    for (var i = 0; i < rest.length; i++) {
      var r = rest[i].getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw) {
        if (io) io.unobserve(rest[i]);
        pending -= 1;
        strip(rest[i]);
      }
    }
    if (pending <= 0 && io) { io.disconnect(); io = null; pending = 0; }
  }

  var freeTimer = null;
  function freeVisibleSoon(ms) {
    if (freeTimer) window.clearTimeout(freeTimer);
    freeTimer = window.setTimeout(function () { freeTimer = null; freeVisible(); }, ms);
  }

  function onIntersect(entries) {
    var batch = [];
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) batch.push(entries[i].target);
    }
    for (var j = 0; j < batch.length; j++) {
      (function (el, idx) {
        if (io) io.unobserve(el);
        pending -= 1;
        var step = idx < MAX_STEP ? idx : MAX_STEP;
        el.style.setProperty('--ft-reveal-i', String(step));
        el.classList.add('is-inview');
        /* Nach Delay + Dauer + Puffer zuruecksetzen — dann gelten wieder
           die normalen Karten-Transitions (Hover), ohne Reveal-Delay. */
        window.setTimeout(function () { strip(el); }, step * STEP_MS + DURATION_MS + 120);
      })(batch[j], j);
    }
    if (pending <= 0 && io) { io.disconnect(); io = null; pending = 0; }
  }

  function scan(root) {
    try {
      var scope = root && root.querySelectorAll ? root : document;
      var groups = scope.querySelectorAll(GROUP_SELECTOR);
      if (!groups.length) return;

      var vw = window.innerWidth || document.documentElement.clientWidth;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var fresh = [];

      for (var g = 0; g < groups.length; g++) {
        var kids = groups[g].children;
        for (var k = 0; k < kids.length; k++) {
          var el = kids[k];
          if (el.classList.contains('ft-reveal')) continue;
          var r = el.getBoundingClientRect();
          /* Schon (teil-)sichtbar => nicht anfassen (Grundsatz 2). Der
             Rechts/Links-Check gilt dem horizontalen Featured-Scroller. */
          if (r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw) continue;
          fresh.push(el);
        }
      }
      if (!fresh.length) return;

      /* Erst ab hier versteckt CSS ueberhaupt etwas — und nur die eben
         eingesammelten Elemente. */
      document.documentElement.classList.add('ft-motion');
      if (!io) io = new IntersectionObserver(onIntersect, { threshold: 0.15 });
      for (var f = 0; f < fresh.length; f++) {
        fresh[f].classList.add('ft-reveal');
        io.observe(fresh[f]);
        pending += 1;
      }
    } catch (e) {
      revealAll();
    }
  }

  /* Hero-Fakten-Chips: gestaffelte Einblendung beim Laden (23.07.2026).
     Die Animation selbst ist reines CSS (Keyframes, fill-mode backwards,
     kein JS-Ticking) — dieses Script liefert nur das Stylesheet und die
     Schalter-Klasse ft-motion-load. Ohne JS existiert beides nicht, also
     ist nie etwas versteckt (Grundsatz 1). Laeuft das Script erst nach
     dem Load-Ende (readyState complete, z. B. bfcache/spaete Injektion),
     wird gar nicht erst injiziert — kein nachtraegliches Verstecken
     bereits gemalter Chips (Grundsatz 2). Media-Query no-preference
     deckt zusaetzlich Laufzeit-Umschaltung auf Reduced-Motion ab: die
     Animation faellt dann einfach weg, Chips stehen voll sichtbar da. */
  function chipIntro() {
    try {
      if (document.readyState === 'complete') return;
      if (!document.querySelector('.ft-hero-fakten')) return;
      var css =
        '@media screen and (prefers-reduced-motion: no-preference) {' +
          'html.ft-motion-load .ft-hero-fakten > span {' +
            'animation: ft-chip-in .42s ease-out backwards;' +
          '}' +
          /* Chip 1 sofort; die Mittelpunkt-Trenner erscheinen jeweils mit
             dem folgenden Chip: Kinder 2+3 => 80 ms, 4+5 => 160 ms —
             drei Stufen im 80-ms-Takt. */
          'html.ft-motion-load .ft-hero-fakten > span:nth-child(2),' +
          'html.ft-motion-load .ft-hero-fakten > span:nth-child(3) { animation-delay: 80ms; }' +
          'html.ft-motion-load .ft-hero-fakten > span:nth-child(4),' +
          'html.ft-motion-load .ft-hero-fakten > span:nth-child(5) { animation-delay: 160ms; }' +
          '@keyframes ft-chip-in { from { opacity: 0; transform: translateY(6px); } }' +
        '}';
      var tag = document.createElement('style');
      tag.textContent = css;
      document.head.appendChild(tag);
      /* Klasse erst NACH dem Stylesheet — es gibt keinen Zustand, in dem
         der Schalter ohne die zugehoerige Animation existiert. */
      document.documentElement.classList.add('ft-motion-load');
    } catch (e) { /* dann eben ohne Chip-Intro — nichts ist versteckt */ }
  }

  /* Reduced-Motion kann zur Laufzeit umgeschaltet werden (OS-Einstellung). */
  if (mq) {
    var onChange = function (ev) { if (ev.matches) revealAll(); };
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onChange);
    else if (typeof mq.addListener === 'function') mq.addListener(onChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { chipIntro(); scan(document); });
  } else {
    chipIntro();
    scan(document);
  }

  /* Ausloeser fuer die Notbremse: einmal kurz nach dem Start (deckt den
     Hintergrund-Tab ab), beim Drehen/Groessenaendern und bei Rueckkehr aus
     dem Verlaufsspeicher. */
  window.setTimeout(function () { freeVisible(); }, 3500);
  window.addEventListener('resize', function () { freeVisibleSoon(250); });
  window.addEventListener('pageshow', function () { freeVisibleSoon(120); });

  /* Beim SCROLLEN mitlaufen. Der Beobachter allein ist zu wenig: faellt er
     aus (Fenster im Hintergrund, vorzeitig abgeschaltet), bleibt der Inhalt
     unsichtbar. Dieser Handler tut dasselbe wie er — freigeben, was im Bild
     steht — und braucht ihn nicht. Passiv und entprellt, kostet also nichts. */
  window.addEventListener('scroll', function () { freeVisibleSoon(140); },
                          { passive: true });

  /* Tab kommt zurueck: waehrend er im Hintergrund lag, meldete der
     Beobachter nichts. */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) freeVisibleSoon(80);
  });

  /* RETTUNGSANKER. Was nach 8 s immer noch versteckt ist, wird sichtbar —
     egal wo es steht. Das kostet die Animation fuer Inhalte, die bis dahin
     niemand erreicht hat, und ist genau der richtige Tausch: lieber ohne
     Animation sichtbar als mit Animation unsichtbar. Ein Laden, in dem
     Inhalte fehlen, verkauft nichts. */
  window.setTimeout(function () { revealAll(); }, 8000);

  /* Theme-Editor: nachgeladene Sektionen einsammeln. */
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev && ev.target) scan(ev.target);
  });
})();
